import { SearchBar } from "@tlc/ls2pac/components/SearchBar";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../../ls2pac/ApplicationData";
import { BaseView } from "../../ls2pac/views/BaseView";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsHistoryManager } from "../managers/HistoryManager";
import { KidsMessaging } from "../messaging";
import { renderWithoutShadow } from "@tlc/ls2pac/components/ShadowUtils";
import * as React from 'react';
import { LibraryThing } from "../../ls2pac/widget/LibraryThingWidget";
import { AccountHolder } from "@tlc/ls2pac/components/Account";
/**
 * The header view contains the search box and its functionality.
 * tlc.ls2kids.views.HeaderView
 * @extends tlc.view.BaseView
 * @constructor
 */
export class KidsHeaderView extends BaseView {
	constructor() {
		super({
			id: LS2KIDS_CONSTANTS.Ids.mainHeader,
			baseTemplate: 'tmpl/kids/headerView.html'
		});

		this.showLogin = window.location.href.indexOf("__SHOW_LOGIN__") > -1;

		this.show();
	}
	/**
	 * @override
	 */
	load() {

		LibraryThing.getConfig().then(({clientCode}) => {
			const container = document.getElementById("search-bar-container");
			renderWithoutShadow(
				<SearchBar
				limitToKids={true}
				maxAuthorSuggestions={0}
				maxTitleSuggestions={0}
				maxPerformedSearchSuggestions={5}
				onClickSearch={(searchEvent) => {
					KidsHistoryManager.navigate(LS2KIDS_CONSTANTS.Urls.search, {
					searchString: searchEvent.searchTerm,
					});
				}}
				syndeticsClientCode={clientCode}
				branchFilters={ApplicationData.locationConfiguration.branchFilters}
				voiceSearchEnabled={false}
				/>,
				container,
			);
		});
		

		this.$view.addClass('structureView');

		this.addListeners();

		var _this = this;

		window.requestAnimationFrame(function () {
			_this.$view.removeClass('hide-opacity');
		});
	}
	handleHeaderLogin(user, isAuthenticated) {
		if (isAuthenticated) {
			var kidsWelcomeGreetingWithName = ApplicationData.language.kidsWelcomeGreeting.replace("%NAME%", user.firstName);
			var loginLinkText = kidsWelcomeGreetingWithName +
				"<br />" +
				ApplicationData.language.logout;

			$("#" + LS2PAC_CONSTANTS.Ids.Header.headerLoginLink)
				.show()
				.html(loginLinkText)
				.attr("class", "logout");

			if(KidsMessaging._currentUser?.id === user?.id){
				// Do not display welcome greeting if it's the same user object that has just been udpated
				return;
			}

			KidsMessaging._currentUser = user;

			// i said who's house?? runs house!!! https://www.youtube.com/watch?v=bCue7oKudbw#t=46
			var kidsWelcomeBackGreetingWithName = ApplicationData.language.kidsWelcomeBackGreeting.replace("%NAME%", user.firstName);

			if (user.firstName == "TLC Admin") {
				KidsMessaging.showThenHide("TLC Admin is in da hizzouse!", 3000);
			} else {
				KidsMessaging.showThenHide(kidsWelcomeBackGreetingWithName, 3000);
			}

		} else {
			$("#" + LS2PAC_CONSTANTS.Ids.Header.headerLoginLink)
				.html(ApplicationData.language.logon)
				.attr("class", "login");

			if (!this.showLogin) {
				$("#" + LS2PAC_CONSTANTS.Ids.Header.headerLoginLink).hide();
			}

			if (KidsMessaging._currentUser != null) {
				var kidsGoodbyeGreetingWithName = ApplicationData.language.kidsGoodbyeGreeting.replace(
					"%NAME%",
					KidsMessaging._currentUser.firstName
				);

				KidsMessaging.showThenHide(kidsGoodbyeGreetingWithName, 2000);
			}

			KidsMessaging._currentUser = null;
		}
	}
	/**
	 * Add any listeners for this specific view.
	 */
	addListeners() {
		var _this = this;
		AccountHolder.subscribe(({user, isAuthenticated}) => this.handleHeaderLogin(user, isAuthenticated));

		$("#" + LS2KIDS_CONSTANTS.Ids.header.headerLoginLink).on("click touchend", function (event) {
			event.preventDefault();

			if ($(event.currentTarget).hasClass('logout')) {
				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onLogout);
			} else {
				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onPromptForLogin);
			}
		});

	}
}











